import { useState } from "react";

interface Props {
  totalMembers: number;
  totalSent: number;
  totalSuccess: number;
  totalFail: number;
  activeMembers: number;
  loading: boolean;
}

export default function AgencyStats({ totalMembers, totalSent, totalSuccess, totalFail, activeMembers, loading }: Props) {
  const [hovered, setHovered] = useState<number | null>(null);

  const successRate = totalSent > 0 ? Math.round((totalSuccess / totalSent) * 100) : 0;

  const cards = [
    {
      label: "하위 회원",
      value: totalMembers,
      unit: "명",
      icon: "ri-team-line",
      color: "from-amber-500 to-orange-500",
      bg: "bg-amber-500/10",
      text: "text-amber-400",
      border: "border-amber-500/20",
    },
    {
      label: "이번 달 발송",
      value: totalSent,
      unit: "건",
      icon: "ri-send-plane-line",
      color: "from-emerald-500 to-teal-500",
      bg: "bg-emerald-500/10",
      text: "text-emerald-400",
      border: "border-emerald-500/20",
    },
    {
      label: "발송 성공률",
      value: successRate,
      unit: "%",
      icon: "ri-checkbox-circle-line",
      color: "from-sky-500 to-cyan-500",
      bg: "bg-sky-500/10",
      text: "text-sky-400",
      border: "border-sky-500/20",
    },
    {
      label: "활성 회원",
      value: activeMembers,
      unit: "명",
      icon: "ri-user-follow-line",
      color: "from-violet-500 to-pink-500",
      bg: "bg-violet-500/10",
      text: "text-violet-400",
      border: "border-violet-500/20",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, idx) => (
        <div
          key={card.label}
          onMouseEnter={() => setHovered(idx)}
          onMouseLeave={() => setHovered(null)}
          className={`relative bg-white/[0.03] border rounded-xl p-5 transition-all duration-300 cursor-default ${card.border} ${hovered === idx ? "bg-white/[0.05] border-opacity-40 scale-[1.02]" : ""}`}
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${card.bg}`}>
              <i className={`${card.icon} ${card.text} text-lg`}></i>
            </div>
            <div className={`w-2 h-2 rounded-full bg-gradient-to-r ${card.color}`}></div>
          </div>
          <div>
            <p className="text-gray-500 text-xs mb-1">{card.label}</p>
            {loading ? (
              <div className="w-16 h-6 bg-white/[0.06] rounded animate-pulse"></div>
            ) : (
              <p className="text-white text-2xl font-bold">
                {card.value.toLocaleString()}
                <span className="text-gray-500 text-sm font-normal ml-1">{card.unit}</span>
              </p>
            )}
          </div>
          {/* Fail count badge for sent card */}
          {!loading && card.label === "이번 달 발송" && totalFail > 0 && (
            <div className="absolute top-4 right-4">
              <span className="text-[10px] font-medium px-1.5 py-0.5 rounded bg-red-500/10 text-red-400 border border-red-500/20 whitespace-nowrap">
                실패 {totalFail.toLocaleString()}건
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}